<template>
  <el-dialog :title="opts.title" :visible.sync="dialogVisible" width="1200px" @close="handleClose">
    <div v-if="pictureZoneUrl">
      <iframe name="pictureZone" title="商品素材空间" :src="pictureZoneUrl" width="100%" height="500px" frameborder="0"></iframe>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button @click="handleClose">取消</el-button>
      <el-button style="margin-right: 10px" type="primary" @click.native="handleOk">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { damPath } from '@/api/login-api';
import { getDamHost } from '@/utils/domainHelper.js';

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      pictureZoneUrl: '',
      damPicList: [],
      opts: {}
    };
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        window.removeEventListener('message', this.messageHandler, false);
      } else {
        window.addEventListener('message', this.messageHandler, false);
      }
    },
  },

  methods: {
    method_open(opts) {
      const defaultOpts = {
        title: '选择图片',
        canCheckDataType: 'file',
        isSingle: true,
        limitSuffix: '.jpg,.jpeg,.png,.gif',
        id: ''
      }
      this.opts = {...defaultOpts, ...opts}
      this.dialogVisible = true;
      this.getDamUrl();
    },
    messageHandler(event) {
      console.log('素材空间===', event);
      const result = (event.origin.includes('.leycloud.com') || event.origin.includes('.leycloud.com')) && event.data;
      if (!result) return;
      const { origin, resource = [], userId, folderPath } = event.data;
      this.damPicList = resource.map(pic => {
        // const filePath = folderPath.map(f => f.name).join('/') + `/${pic.name}`
        const filePath = folderPath.map(f => f.name).join('/')
        return {
          id: pic.id,
          name: pic.name,
          url: origin + pic.url,
          fileInfo: pic.fileInfo,
          fileFeature: pic.fileFeature,
          damUserId: userId,
          filePath
        };
      });
    },
    getDamUrl() {
      // 对接文档
      // https://gykj.yuque.com/zc06bu/uh6t18/ussewz#uN73L     
      damPath().then(res => {
        const fileTypes = (this.opts.limitSuffix || '').replace(/\./g, '');
        const params = encodeURIComponent(
          `showSideMenu=false&mode=pick${this.opts.id ? `&id=${this.opts.id}` : ''}&canCheckDataType=${this.opts.canCheckDataType}&fileTypeList=${fileTypes}&isMultiChoice=${!this.opts.isSingle}`
        );
        this.pictureZoneUrl = res.data.damPath + `&redirect=//` + getDamHost() + `/dam/disk/space2?` + params;
      });
    },
    handleOk() {
      if (!this.damPicList.length) {
        return this.$message.warning(`请选择${this.opts.canCheckDataType === 'file' ? '图片' : '素材包'}！`);
      }
      const damPicList = JSON.parse(JSON.stringify(this.damPicList));
      this.handleClose();
      this.$nextTick(() => {
        this.opts.okFn && this.opts.okFn(damPicList)
      });
    },

    handleClose() {
      this.dialogVisible = false;
    },
  },
  mounted() {},
};
</script>
  
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  height: auto;
  padding-bottom: 0;
  min-height: 100px;
}
::v-deep .el-dialog__footer {
  .el-button {
    position: relative;
    z-index: 10;
  }
}
</style>